import styled from "styled-components";

export const SelectTicketContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const Row = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    gap: 16px;
`;

export const ColumnSearch = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ColumnForms = styled.div`
    width: 25%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const SearchTicketContainer = styled.div`
    border: 1px solid #D8DCDE;
    border-radius: 4px;
    background-color: #FFFFFF;
    height: 252px;

    display: flex;
    flex-direction: column;
`;

export const ShowTicketContainer = styled.div``;

export const TicketFormContainer = styled.div`
    border: 1px solid #D8DCDE;
    border-radius: 4px;
    background-color: #FFFFFF;
    max-width: 380px;
    height: 100%;

    display: flex;
    flex-direction: column;
`;

export const SearchTop = styled.div`
    padding: 16px 24px;
    border-bottom: 1px solid #D8DCDE;

    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;

    h1 {
        font-size: 24px;
        color: #414141;
        font-weight: 500;
    } 

    p{
        font-size: 16px;
        color: #5863F8;
        font-weight: 500;
    }
`;

export const SearchOptionsList = styled.ul`
    color: #414141;
    display: flex;
    flex-direction: row;
    gap: 10px;
`;
interface SearchOptionsItemProps {
    selected: boolean;
}
export const SearchOptionsItem = styled.ul<SearchOptionsItemProps>`
    max-width: ${({ selected }) => (selected ? "105px" : "113px")};
    height: 40px;
    
    opacity: 1;
    box-shadow: ${({ selected }) =>
        selected ? "0px -3px 0px 0px #5863F8 inset" : "0px -1px 0px 0px transparent inset"};

    padding-top: 10px;
    padding-right: 28px;
    padding-bottom: 10px;
    padding-left: 28px;

    font-family: Inter;
    font-weight: ${({ selected }) => (selected ? "600" : "400")};;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.15px;
    text-align: center;
    color: ${({ selected }) => (selected ? "#2F5BFF" : "#6B7177")};

    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover{
        ${({ selected }) => !selected && `
            color: #2F5BFF;
            border-bottom: 3px solid #5863F8;
            font-weight: 600;
        `}
    }
`;

export const SearchMiddle = styled.div`
    padding: 16px;
    border-bottom: 1px solid #D8DCDE;

    display: flex;
    justify-content: space-between;
    flex-direction: column;
`;

export const SearchBar = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
    flex-direction: row;
    gap: 12px;
    z-index: 1000;
`;

export const SearchInput = styled.input`
    margin-left: -14px;
    width: 45%;
    font-weight: 400;
    font-size: 14px;
    border: 1px solid  #A8B1B9;
    padding: 10px 12px;
    border-radius: 4px;
    color: #9A9FA2; 
    outline: none;
`;

export const SearchButton = styled.button`
    max-width: 110px;
    height: 40px;

    padding: 10px 16px;
    gap: 8px;

    border-radius: 4px;
    border: none;

    background-color: var(--cx-blue, #2F5BFF);
    color: #ffffff;

    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.15px;
    font-family: Inter;
    text-align: center;


    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const FilterBar = styled.div`
    max-width: 1050px;
    overflow-x: scroll;
    overflow-y: hidden;
    margin-top: 12px;
    gap: 4px;
    display: flex;
    flex-direction: row;
`;

export const Tag = styled.div`
    background: var(--grey-100, #DDE0E3);

    border-radius: 4px;
    padding-top: 4px;
    padding-right: 0px;
    padding-bottom: 4px;
    padding-left: 12px;

    display: flex;
    flex-direction: row;
`;

export const TagWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;
`;

export const TagOption = styled.p`
    font-family: Inter;
    font-weight: 600;
    font-size: 12px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: center;

`;

export const TagValue = styled.p`
    font-family: Inter;
    font-weight: 400;
    font-style: Regular;
    font-size: 12px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: center;
`;

export const RemoveTagButton = styled.button`   
    width: 24px;
    height: 24px;
    margin-left: 0px; 
    background: None;
    border: None;
    background-image: url("data:image/svg+xml;utf8,<svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M8.64648 2.64648C8.84175 2.45122 9.15825 2.45122 9.35352 2.64648C9.54878 2.84175 9.54878 3.15825 9.35352 3.35352L6.70703 6L9.35352 8.64648C9.54878 8.84175 9.54878 9.15825 9.35352 9.35352C9.15825 9.54878 8.84175 9.54878 8.64648 9.35352L6 6.70703L3.35352 9.35352C3.15825 9.54878 2.84175 9.54878 2.64648 9.35352C2.45122 9.15825 2.45122 8.84175 2.64648 8.64648L5.29297 6L2.64648 3.35352C2.45122 3.15825 2.45122 2.84175 2.64648 2.64648C2.84175 2.45122 3.15825 2.45122 3.35352 2.64648L6 5.29297L8.64648 2.64648Z' fill='%236B7177'/></svg>");
    background-repeat: no-repeat;
    background-position: right 6px center;
`;

export const RemoveAllTagsButton = styled.button`   
    background: None;
    border: None;

    max-width: 109px;
    height: 32px;
    border-radius: 4px;
    gap: 8px;

    padding-top: 8px;
    padding-right: 12px;
    padding-bottom: 8px;
    padding-left: 12px;

    font-family: Inter;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: center;
    color: var(--cx-blue, #2F5BFF);

`;

export const SearchBottom = styled.div`
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`

export const FileUploadContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    h3 {
        margin: 0;
        font-size: 14px;
        color: #2F3941;
    }

    p {
        margin: 0;
        font-size: 12px;
        color: #2F3941;
    }
`

export const UploadButtonContainer = styled.div`
    margin-left: 8px;
`

export const DownloadSpreadsheetButton = styled.button`
    background: None;
    border: None;

    max-width: 231px;
    height: 40px;
    border-radius: 4px;
    gap: 8px;
    padding-top: 10px;
    padding-right: 16px;
    padding-bottom: 10px;
    padding-left: 16px;
    
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.15px;
    text-align: center;
    color: var(--cx-blue, #2F5BFF);

    background-image: url("data:image/svg+xml;utf8,<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M14.5 15C14.7761 15 15 15.2239 15 15.5C15 15.7761 14.7761 16 14.5 16H1.5C1.22386 16 1 15.7761 1 15.5C1 15.2239 1.22386 15 1.5 15H14.5ZM8 0C8.27614 0 8.5 0.223858 8.5 0.5V11.6934L12.0469 8.14648C12.2422 7.95142 12.5587 7.95129 12.7539 8.14648C12.9489 8.3417 12.9489 8.6583 12.7539 8.85352L8.65332 12.9531C8.25806 13.3484 7.64136 13.3484 7.24609 12.9531L3.14648 8.85352C2.95122 8.65825 2.95122 8.34175 3.14648 8.14648C3.34175 7.95122 3.65825 7.95122 3.85352 8.14648L7.5 11.793V0.5C7.5 0.223858 7.72386 0 8 0Z' fill='%232F5BFF'/></svg>");
    background-repeat: no-repeat;
    background-position: left 4px center;
`

export const UploadSpreadsheetButton = styled.button`
    background-color: transparent;
    border: 1px solid var(--cx-blue, #2F5BFF);
    padding: 10px 16px;
    border-radius: 4px;
    color: var(--cx-blue, #2F5BFF);
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
`

export const ResponseHeader = styled.div`
    padding: 12px 24px ;
    border-bottom: 1px solid #D8DCDE;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    #header-wrapper{
        gap: 8px;
        display: flex;
        align-items: center;
    }
`

export const ResponseHeaderOption = styled.div`
    color: #373A3E;
    font-size: 14px;
    font-weight: 600;
`

export const ResponseHeaderQuantity = styled.div`
    min-width: 40px;
    min-height: 20px;
    border-radius: 2px;
    gap: 4px;
    padding-top: 2px;
    padding-right: 8px;
    padding-bottom: 2px;
    padding-left: 8px;
    background: var(--cx-blue, #2F5BFF);

    font-family: Inter;
    font-weight: 600;
    font-size: 12px;
    leading-trim: NONE;
    line-height: 16px;
    letter-spacing: 0px;
    text-align: center;
    color: #FFFFFF;
`

export const ResponseHeaderDownloadButton = styled.button`
    background: None;
    border: None;
    min-width: 155px;
    min-height: 40px;
    border-radius: 4px;
    gap: 8px;

    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: -0.15px;
    text-align: center;
    color: var(--cx-blue, #2F5BFF);

    background-image: url("data:image/svg+xml;utf8,<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M14.5 15C14.7761 15 15 15.2239 15 15.5C15 15.7761 14.7761 16 14.5 16H1.5C1.22386 16 1 15.7761 1 15.5C1 15.2239 1.22386 15 1.5 15H14.5ZM8 0C8.27614 0 8.5 0.223858 8.5 0.5V11.6934L12.0469 8.14648C12.2422 7.95142 12.5587 7.95129 12.7539 8.14648C12.9489 8.3417 12.9489 8.6583 12.7539 8.85352L8.65332 12.9531C8.25806 13.3484 7.64136 13.3484 7.24609 12.9531L3.14648 8.85352C2.95122 8.65825 2.95122 8.34175 3.14648 8.14648C3.34175 7.95122 3.65825 7.95122 3.85352 8.14648L7.5 11.793V0.5C7.5 0.223858 7.72386 0 8 0Z' fill='%232F5BFF'/></svg>");
    background-repeat: no-repeat;
    background-position: left 4px center;
`


export const ContainerTable = styled.div`
  flex: 1;   
  min-height: 0;       
  padding: 0;
  width: 100%;
  height: 100vh;
  background-color: white;
  border-radius: 4px;
  border: 1px solid #D8DCDE;

  &.noContent {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60vh;
  }

  &.noContent p {
    color: #9A9FA2;
    font-size: 14px;
    text-align: center;
  }

`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
`;

export const PageInfo = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  color: #414141;
`;

export const CenterKLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
`;